import { WorldClockLog } from '../../models/world-clock-log.model';

export const WORLD_CLOCK_DATA: WorldClockLog[] = [
  {
    id: '1',
    market: 'PG&E/SCE',
    timeZone: 'PST',
    utcOffset: '-8',
    ianaTimeZone: 'America/Los_Angeles',
    locale: 'en-US',
  },
  {
    id: '2',
    market: 'SRP',
    timeZone: 'MST',
    utcOffset: '-7',
    ianaTimeZone: 'America/Phoenix',
    locale: 'en-US',
  },
  {
    id: '3',
    market: 'AESO',
    timeZone: 'MST',
    utcOffset: '-7',
    ianaTimeZone: 'America/Denver',
    locale: 'en-US',
  },
  {
    id: '4',
    market: 'ERCOT/TVA',
    timeZone: 'CST',
    utcOffset: '-6',
    ianaTimeZone: 'America/Chicago',
    locale: 'en-US',
  },
  {
    id: '5',
    market: 'IESO',
    timeZone: 'EST',
    utcOffset: '-5',
    ianaTimeZone: 'EST',
    locale: 'en-US',
  },
  {
    id: '6',
    market: 'PJM/NYISO/ISONE',
    timeZone: 'EST',
    utcOffset: '-5',
    ianaTimeZone: 'America/New_York',
    locale: 'en-US',
  },
  {
    id: '7',
    market: 'Enel Chile',
    timeZone: 'CLST',
    utcOffset: '-3',
    ianaTimeZone: 'America/Santiago',
    locale: 'es-CL',
  },
  {
    id: '8',
    market: 'UTC',
    timeZone: 'UTC',
    utcOffset: '±0',
    ianaTimeZone: 'UTC',
    locale: 'en-GB',
  },
  {
    id: '9',
    market: 'EirGrid/NGrid UK',
    timeZone: 'WEST',
    utcOffset: '+1',
    ianaTimeZone: 'WET',
    locale: 'en-GB',
  },
  {
    id: '10',
    market: 'PSE/TERNA/SRAD',
    timeZone: 'CEST',
    utcOffset: '+2',
    ianaTimeZone: 'Europe/Rome',
    locale: 'en-GB',
  },
  {
    id: '11',
    market: 'Taipower',
    timeZone: 'CST',
    utcOffset: '+8',
    ianaTimeZone: 'Asia/Taipei',
    locale: 'zh-TW',
  },
  {
    id: '13',
    market: 'IMO-WA',
    timeZone: 'AWST',
    utcOffset: '+8',
    ianaTimeZone: 'Australia/Perth',
    locale: 'en-AU',
  },
  {
    id: '14',
    market: 'KPX',
    timeZone: 'KST',
    utcOffset: '+9',
    ianaTimeZone: 'Asia/Seoul',
    locale: 'ko-KR',
  },
  {
    id: '15',
    market: 'TEPCO/KEPCO',
    timeZone: 'JST',
    utcOffset: '+9',
    ianaTimeZone: 'Asia/Tokyo',
    locale: 'ja-JP',
  },
  {
    id: '16',
    market: 'AEMO/ERM',
    timeZone: 'AEST',
    utcOffset: '+10',
    ianaTimeZone: 'Australia/Sydney',
    locale: 'en-AU',
  },
  {
    id: '17',
    market: 'AusNet',
    timeZone: 'AEST',
    utcOffset: '+10',
    ianaTimeZone: 'Australia/Melbourne',
    locale: 'en-AU',
  },
  {
    id: '18',
    market: 'Transpower',
    timeZone: 'NZST',
    utcOffset: '+12',
    ianaTimeZone: 'Pacific/Auckland',
    locale: 'en-AU',
  },
];
